import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onFlyoutButtonHover = action("onFlyoutButtonHover", event => ({
    event,
    owaType: "flyoutButtonHover",
})) as OwaNovaActionUnion<"flyoutButtonHover">;
